const rootArea = "/tokens";

export const tokenGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (configCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${configCode}/read`
	})
});